import React, { useEffect, useState } from 'react';
import ChartRanking from './ChartRanking';
import { ResponsiveContainer } from 'recharts';
import MediaChart from './MediaChart';
import UserChart from './UserChart';
import Ranking from './Ranking';

// import ranking1 from './images/escudo_ranking1.png';
// import ranking2 from './images/escudo_ranking2.png';
// import ranking3 from './images/escudo_ranking3.png';

export default function UserView(props) {

    const {
        percentageHeight,
        chartData,
        media,
        first,
        second,
        third,
    } = props?.data

    return (

        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
                width: '100%',
                // height: percentageHeight ? ((window.innerHeight / 100) * percentageHeight) : '100%',
                minHeight: 'calc(100dvh - 100px)',
                maxHeight: 'calc(100dvh - 100px)',
                zIndex: 5,
                overflowY: 'auto',
            }}
        >
            {chartData?.length > 0 &&
                <div className='mt-[20px]' style={{ width: '100%', height: 'fit-content' }}>
                    {/* <div className='flex flex-row justify-evenly'>
                        <div className='flex relative'>
                            <div style={{
                                width: 100,
                                minWidth: 100,
                                aspectRatio: '1/1',
                                position: 'absolute',
                                top: 110,
                                left: 40,
                                borderRadius: '100%',
                                overflow: 'hidden',
                                border: '1px solid #fff5'
                            }}
                            >
                                <img style={{ width: '100%', objectFit: 'contain' }} src={second?.avatar} />
                            </div>
                            <img style={{ minWidth: 180, width: 180, objectFit: 'contain' }} src={ranking2} />
                        </div>
                        <div className='flex relative'>
                            <div style={{
                                width: 130,
                                minWidth: 130,
                                aspectRatio: '1/1',
                                position: 'absolute',
                                top: 90,
                                left: 75,
                                borderRadius: '100%',
                                overflow: 'hidden',
                                border: '1px solid #fff5'
                            }}
                            >
                                <img style={{ width: '100%', objectFit: 'contain' }} src={first?.avatar} />
                            </div>
                            <img style={{ minWidth: 280, width: 280, objectFit: 'contain' }} src={ranking1} />
                        </div>
                        <div className='flex relative'>
                            <div style={{
                                width: 100,
                                minWidth: 100,
                                aspectRatio: '1/1',
                                position: 'absolute',
                                top: 110,
                                left: 40,
                                borderRadius: '100%',
                                overflow: 'hidden',
                                border: '1px solid #fff5'
                            }}
                            >
                                <img style={{ width: '100%', objectFit: 'contain' }} src={third?.avatar} />
                            </div>
                            <img style={{ minWidth: 180, width: 180, objectFit: 'contain' }} src={ranking3} />
                        </div>
                    </div> */}
                    <Ranking data={{ first, second, third, chartData }} />
                    <div className='mt-[40px] mx-4 py-2 border-t-[1px] border-t-[#c3c3c355]'>
                        <span className='ml-[30px]'>Sua pontuação</span>
                        <UserChart chartHeight={100} barHeight={100} data={chartData} />
                    </div>

                    <div className='mx-4 py-2 border-t-[1px] border-t-[#c3c3c355]'>
                        <span className='ml-[30px]'>Média da Equipe</span>
                        <MediaChart media={[{ name: 'Média da Equipe', value: parseFloat(media.toFixed(2)), amt: 80 }]} chartHeight={120} barHeight={120} />
                    </div>
                    

                </div>
            }
        </div>

        // <div style={{ display: 'flex', flexGrow: 1, width: '100%', height: '100%', paddingTop: 30 }}>
        //     {chartData?.length > 0 &&
        //         <ChartRanking percentageHeight={percentageHeight} data={chartData} media={media} />
        //     }
        // </div>

    );
}